angular.module("vgresiduos").factory("disposalStepControlService", [
	function () {
		"use strict";

		const DRIVER_VALIDATION_TYPES = [
			Vgr.enumerations.validation.DriverLicenseWithoutExpirationDate,
			Vgr.enumerations.validation.DriverLicenseExpired,
			Vgr.enumerations.validation.DriverWithoutMopp,
			Vgr.enumerations.validation.DriverMoppExpired,
			Vgr.enumerations.validation.DriverRequired
		];

		const VEHICLE_VALIDATION_TYPES = [
			Vgr.enumerations.validation.VehicleWithoutInmetroCertificate,
			Vgr.enumerations.validation.VehicleWithInmetroCertificateExpired,
			Vgr.enumerations.validation.VehicleRequired
		];

		const DRIVER_VEHICLE_VALIDATION_TYPES = [...DRIVER_VALIDATION_TYPES, ...VEHICLE_VALIDATION_TYPES];

		const _processTransporterValidations = function (validations, scope, transporterValid) {
			const blockingValidations = validations.filter((v) => v.IsToBlock);

			if (scope.isSolicitationStage()) {
				_handleSolicitationStage(blockingValidations, scope, transporterValid);
			} else if (scope.isGatheringStage()) {
				_handleGatheringStage(blockingValidations, scope, transporterValid);
			}
		};

		function _handleSolicitationStage(blockingValidations, scope, transporterValid) {
			if (transporterValid) {
				const nextStep = scope.isTemporaryStorage() ? scope.stepsEnum.F : scope.stepsEnum.E;

				const driverAndVehicleValidations = blockingValidations.filter((v) =>
					DRIVER_VEHICLE_VALIDATION_TYPES.includes(v.Type)
				);
				if (driverAndVehicleValidations.length > 0) {
					scope.enableBackToStep(nextStep);
					_setStepValidationMessage(scope.stagesEnum.Solicitation, nextStep, driverAndVehicleValidations, scope);
				} else {
					scope.enableStep(scope.stepsEnum.H);
					_clearStepValidationMessage(scope.stagesEnum.Solicitation, nextStep, scope);
				}
			} else {
				const transporterStep = scope.isTemporaryStorage() ? scope.stepsEnum.E : scope.stepsEnum.D;
				scope.enableBackToStep(transporterStep);
				scope.stagesConfig[scope.stagesEnum.Solicitation].Steps[scope.stepsEnum.D].MiddleActionEnabled = false;
			}
		}

		function _handleGatheringStage(blockingValidations, scope, transporterValid) {
			const driverValidations = blockingValidations.filter((v) => DRIVER_VALIDATION_TYPES.includes(v.Type));
			const vehicleValidations = blockingValidations.filter((v) => VEHICLE_VALIDATION_TYPES.includes(v.Type));
			const otherValidations = blockingValidations.filter((v) => !DRIVER_VEHICLE_VALIDATION_TYPES.includes(v.Type));

			_clearStepValidationMessage(scope.stagesEnum.Gathering, scope.stepsEnum.B, scope);
			_clearStepValidationMessage(scope.stagesEnum.Gathering, scope.stepsEnum.C, scope);

			if (transporterValid) {
				if (driverValidations.length > 0) {
					scope.enableBackToStep(scope.stepsEnum.B);
					_setStepValidationMessage(scope.stagesEnum.Gathering, scope.stepsEnum.B, driverValidations, scope);
				} else if (vehicleValidations.length > 0) {
					scope.enableBackToStep(scope.stepsEnum.C);
					_setStepValidationMessage(scope.stagesEnum.Gathering, scope.stepsEnum.C, vehicleValidations, scope);
				} else if (otherValidations.length > 0) {
					scope.enableBackToStep(scope.stepsEnum.E);
				} else {
					scope.enableStep(scope.stepsEnum.F);
				}
			} else {
				scope.enableBackToStep(scope.stepsEnum.A);
			}
		}

		function _setStepValidationMessage(stage, step, validations, scope) {
			const errorMessage = validations.map((v) => scope.getCustomValidationMessage(v)).join("\n");
			if (scope.stagesConfig[stage] && scope.stagesConfig[stage].Steps[step]) {
				scope.stagesConfig[stage].Steps[step].CustomValidationMessage = errorMessage;
				scope.stagesConfig[stage].Steps[step].MiddleActionEnabled = false;
			}
		}

		function _clearStepValidationMessage(stage, step, scope) {
			if (scope.stagesConfig[stage] && scope.stagesConfig[stage].Steps[step]) {
				scope.stagesConfig[stage].Steps[step].CustomValidationMessage = "";
				scope.stagesConfig[stage].Steps[step].MiddleActionEnabled = true;
			}
		}

		function _determineGatheringStep(validations, scope) {
			if (!scope.destinationModel.Transporter) {
				return scope.stepsEnum.A;
			}

			const driverVehicleValidations = validations.filter(
				(v) => DRIVER_VEHICLE_VALIDATION_TYPES.includes(v.Type) && v.IsToBlock
			);
			const driverValidations = driverVehicleValidations.filter((v) => DRIVER_VALIDATION_TYPES.includes(v.Type));
			const vehicleValidations = driverVehicleValidations.filter((v) => VEHICLE_VALIDATION_TYPES.includes(v.Type));

			if (!scope.destinationModel.Driver || driverValidations.length > 0) {
				return scope.stepsEnum.B;
			}
			if (!scope.destinationModel.Vehicle || vehicleValidations.length > 0) {
				return scope.stepsEnum.C;
			}
			if (scope.stagesConfig[scope.stagesEnum.Gathering].Steps[scope.stepsEnum.D].IsDisabled) {
				return scope.stepsEnum.E;
			}
			return scope.stepsEnum.D;
		}

		return {
			processTransporterValidations: _processTransporterValidations,
			determineGatheringStep: _determineGatheringStep,
			driverVehicleValidationTypes: DRIVER_VEHICLE_VALIDATION_TYPES
		};
	}
]);
